import { THEME_PREFIX } from "../../inc/constants";
const timerDelay = 200;
const hoverDelay = 250;
const timers = {};

import "./styles/view.scss";

// Only activate the script if the screen is not small (>= 768px)
function handleMegaMenuScript() {
	if (window.innerWidth >= 768) {
		jQuery(function ($) {

			function hideMenus($menu) {
				$(`.wp-block-madden-blocks-mega-menu`).each(function () {
					if (!$(this).is($menu)) {
						hideMenu($(this), $(this).data("id"));
					}
				});
			}

			function showMenu($menu, megaMenuId) {
				if (window.innerWidth < 768) {
					return;
				}
				hideMenus($menu);
				$(this).css("zIndex", 2);
				$menu.addClass("active hoverable visible");
				$(`li[data-megamenu="${megaMenuId}"]`).addClass("active hover");
			}

			function hideMenu($menu, megaMenuId) {
				$(this).css("zIndex", 1);
				$menu.removeClass("active hoverable visible");
				$(`li[data-megamenu="${megaMenuId}"]`).removeClass("active hover");
			}

			(function () {
				function initMegaMenu($menuItem) {
					var megaMenuId = $menuItem.data("megamenu");
					const $menu = $(`.wp-block-madden-blocks-mega-menu--${megaMenuId}`);

					$menuItem.hover(
						function (e) {
							clearTimeout(timers[`${megaMenuId}Hover`]);
							clearTimeout(timers[`${megaMenuId}Active`]);
							showMenu($menu, megaMenuId);
						},
						function () {
							// moved to mouseleave event for main nav
						}
					);

					$('#main-nav').mouseleave(() => {
						clearTimeout(timers[`${megaMenuId}Hover`]);
						timers[`${megaMenuId}Hover`] = setTimeout(() => {
							$menu.removeClass("visible");
							$menuItem.removeClass("active");
						}, hoverDelay);

						clearTimeout(timers[`${megaMenuId}Active`]);
						timers[`${megaMenuId}Active`] = setTimeout(() => {
							hideMenu($menu, megaMenuId);
							$menu.removeClass("hoverable");
						}, timerDelay);
					});

					$menu.hover(
						function (e) {
							clearTimeout(timers[`${megaMenuId}Hover`]);
							clearTimeout(timers[`${megaMenuId}Active`]);
							showMenu($menu, megaMenuId);
						},
						function () {
							$menu.removeClass("visible");
							$menuItem.removeClass("active hover");
							clearTimeout(timers[`${megaMenuId}Active`]);
							timers[`${megaMenuId}Active`] = setTimeout(() => {
								hideMenu($menu, megaMenuId);
							}, timerDelay);
						}
					);
				}

				$("li[data-megamenu]").each(function () {
					initMegaMenu($(this));
				});
			})();
		});
	}
}

// Initial check
handleMegaMenuScript();

// Re-check on resize
window.addEventListener("resize", function () {

	if (
		(window.innerWidth >= 768 && !window.megaMenuScriptActive) ||
		(window.innerWidth < 768 && window.megaMenuScriptActive)
	) {
		window.location.reload();
	}
	window.megaMenuScriptActive = window.innerWidth >= 768;
});
window.megaMenuScriptActive = window.innerWidth >= 768;